var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57369 3.24452L6.24452 6.57785L6.17452 6.65702C6.05025 6.81745 5.9888 7.01772 6.00168 7.22025C6.01457 7.42277 6.10092 7.61363 6.24452 7.75702L6.32369 7.82619C6.48412 7.95046 6.68439 8.01191 6.88691 7.99902C7.08944 7.98614 7.2803 7.89979 7.42369 7.75619L9.33369 5.84202V15.5004L9.33952 15.5979C9.36321 15.8007 9.46058 15.9878 9.61312 16.1236C9.76567 16.2594 9.96278 16.3345 10.167 16.3345L10.2645 16.3287C10.4674 16.3048 10.6544 16.2072 10.79 16.0545C10.9257 15.9018 11.0005 15.7046 11.0004 15.5004V5.84785L12.9112 7.75619L12.9904 7.82619C13.1579 7.95729 13.3692 8.01936 13.581 7.9997C13.7928 7.98004 13.989 7.88012 14.1296 7.72043C14.2701 7.56074 14.3442 7.35335 14.3368 7.14077C14.3293 6.92818 14.2409 6.72649 14.0895 6.57702L10.7512 3.24369L10.6729 3.17452C10.5124 3.05025 10.3122 2.9888 10.1096 3.00168C9.9071 3.01457 9.71708 3.10092 9.57369 3.24452Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpBlack);
export default __webpack_public_path__ + "static/media/ArrowUpBlack.f2500683e6dbd7eed5cd5ad9be3261a4.svg";
export { ForwardRef as ReactComponent };